import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from './Card';
const steps = [{
  number: '01',
  title: 'Comprehensive Evaluation',
  description: 'We start with a detailed neurological exam to determine the exact extent of your nerve damage and identify the root cause.'
}, {
  number: '02',
  title: 'Personalized Plan',
  description: 'Based on your results, we design a customized, drug-free treatment protocol tailored to your specific condition and goals.'
}, {
  number: '03',
  title: 'Advanced Therapy',
  description: 'We utilize state-of-the-art, FDA-cleared technologies designed to stimulate nerve regeneration and increase blood flow.'
}, {
  number: '04',
  title: 'Lasting Relief',
  description: "Our goal isn't just temporary symptom management, but helping your body heal so you can return to an active, pain-free life."
}];
export function HowItWorks() {
  return <section id="treatments" className="py-20 bg-primary text-primary-foreground" data-id="element-187">
      <div className="container mx-auto px-4" data-id="element-188">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-189">
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4" data-id="element-190">
            Our Drug-Free, Non-Surgical Approach
          </h2>
          <p className="text-lg text-primary-foreground/80" data-id="element-191">
            We don't just mask the pain with medications. Our comprehensive
            protocol is designed to address the root cause of neuropathy and
            promote natural healing.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-192">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} data-id="element-193">
              <Card className="h-full bg-background/10 border-none text-primary-foreground backdrop-blur-sm" data-id="element-194">
                <CardContent className="p-6 flex flex-col gap-4" data-id="element-195">
                  <span className="text-4xl font-heading font-bold text-primary-foreground/30" data-id="element-196">
                    {step.number}
                  </span>
                  <h3 className="font-bold text-xl" data-id="element-197">{step.title}</h3>
                  <p className="text-primary-foreground/80 leading-relaxed" data-id="element-198">
                    {step.description}
                  </p>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}